var parseDate;

parseDate = function(value) {
  if (value && typeof value === 'string') {
    return moment(value, 'YYYY/MM/DD HH:mm');
  } else {
    return value;
  }
};

angular.module('gym.calendar').factory('EditEventScheduleService', ["$modal", "$q", "Calendar", "EventDefaultsService", function($modal, $q, Calendar, EventDefaultsService) {
  return {
    getDailySession: function(event, startTime) {
      var durationHours, durationMinutes, endTime, start;
      startTime = startTime || event.start_time || parseDate(event.start_at) || EventDefaultsService.getRoundedTime(moment());
      start = moment(startTime);
      durationHours = event.duration_hours || '0';
      durationMinutes = event.duration_minutes || '0';
      endTime = start.clone().add(durationHours, 'hours').add(durationMinutes, 'minutes');
      return {
        start_at: start.format('h:mma'),
        start_at_obj: start.toDate(),
        end_at: endTime.format('h:mma'),
        end_at_obj: endTime.toDate()
      };
    },
    setDailySession: function(event, day) {
      event.daily_sessions = {};
      return event.daily_sessions[day] = [this.getDailySession(event)];
    },
    onDailySessionEndTimeChanged: function(session) {
      if (!moment(session.end_at_obj).isValid()) {
        session.end_at_obj = moment().toDate();
      }
      return session.end_at = moment(session.end_at_obj).format('h:mma');
    },
    isDaySelected: function(event, index) {
      var ref, ref1;
      return (ref = event.daily_sessions) != null ? (ref1 = ref[index]) != null ? ref1.length : void 0 : void 0;
    },
    toggleDay: function(event, changeAttributes, index) {
      changeAttributes.daily_sessions || (changeAttributes.daily_sessions = {});
      if (this.isDaySelected(changeAttributes, index)) {
        return delete changeAttributes.daily_sessions[index];
      } else {
        return changeAttributes.daily_sessions[index] = [this.getDailySession(event)];
      }
    },
    isCopyDaySelected: function(dayIndex, copyDay, dailySessionWdays) {
      var days;
      days = dailySessionWdays[dayIndex];
      return _.find(days, function(day) {
        return day === copyDay;
      }) != null;
    },
    toggleCopyDay: function(dayIndex, copyDayIndex, dailySessionWdays) {
      var day;
      day = dailySessionWdays[dayIndex];
      if (this.isCopyDaySelected(dayIndex, copyDayIndex, dailySessionWdays)) {
        return dailySessionWdays[dayIndex] = _.without(day, copyDayIndex);
      } else {
        dailySessionWdays[dayIndex].push(copyDayIndex);
        return dailySessionWdays[dayIndex] = _.sortBy(dailySessionWdays[dayIndex], function(day) {
          return day;
        });
      }
    },
    copySession: function(event, day, wdays) {
      return _.each(wdays[day], (copyDay) => {
        return event.daily_sessions[copyDay] = angular.copy(event.daily_sessions[day]);
      });
    },
    isWeeklyEventReady: function(event) {
      return event.wdays.length && (event.repeats || event.repeat_until || event.repeat_until_date || event.repeat_type === 'infinite');
    },
    precheck: function(eventId, params) {
      var deferred, p;
      deferred = $q.defer();
      p = angular.extend({
        withoutNamespace: true
      }, params);
      Calendar.one('frequency_update_prechecks', eventId).customPUT(p).then(function(response) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/calendar/events/edit_event_schedule/precheck_modal.html.slim'),
          resolve: {
            precheck: function() {
              return response;
            }
          },
          controller: ["$scope", "$modalInstance", "precheck", function($scope, $modalInstance, precheck) {
            var expectedChanges;
            $scope.precheck = precheck;
            $scope.displayChangesDetails = {};
            expectedChanges = precheck.expected_changes;
            $scope.hasMultipleChanges = expectedChanges && _.compact([expectedChanges.added_event_count, expectedChanges.removed_event_count, expectedChanges.moved_event_count, expectedChanges.removed_booking_count]).length > 1;
            $scope.confirm = function() {
              $modalInstance.close();
              return deferred.resolve();
            };
            return $scope.cancel = function() {
              $modalInstance.dismiss('cancel');
              return deferred.reject();
            };
          }]
        });
        return modalInstance.result.then(function() {
          return angular.noop;
        }, function() {
          return deferred.reject();
        });
      });
      return deferred.promise;
    },
    updateFrequency: function(eventId, params) {
      var p;
      p = angular.extend({
        withoutNamespace: true
      }, params);
      return Calendar.one('events', eventId).customPUT(p, 'update_frequency');
    }
  };
}]);
